import {useCallback, useEffect, useState} from 'react'
import {MenuItem} from '../types/MenuItem'
import {getCompanyFeatures, getDashboardMenu } from '../api/index'
import {isSuperAdmin} from '../modules/auth'
import {getSellerMenu, getToolsMenu, getLojistasrMenu} from '../data-layer/MenuData'

export const useUsermenuData = () => {
  const [menuData, setMenuData] = useState<MenuItem[]>([])
  const [isFetching, setIsFetching] = useState<boolean>(true)

  const fetchDashboardMenu = useCallback(async () => {
    const response = await getDashboardMenu()
    const menuItems = (response.data || []).filter((x:any) => x.children && x.children.length > 0)
    return menuItems
  }, [])

  const fetchToolsMenu = useCallback(async (features:any) => {
    return getToolsMenu(features, isSuperAdmin())
  }, [])

  const fetchSalesMenu = useCallback(async () => {
    return getSellerMenu()
  }, [])

  const fetchLojistasMenu = useCallback(async (features:any) => {
    return getLojistasrMenu(features)
  }, [])

  const fetchData = useCallback(async () => {
    setIsFetching(true)

    const result = await getCompanyFeatures()
    const features = result.data || [];

    console.log(features);

    const dashboardMenu = await fetchDashboardMenu()
    const toolsMenu = await fetchToolsMenu(features)
    const salesMenu = await fetchSalesMenu()
    const lojistasMenu = await fetchLojistasMenu(features)

    const items = [...dashboardMenu, ...toolsMenu, ...salesMenu, ...lojistasMenu]

    setMenuData(items)
    setIsFetching(false)
  }, [fetchDashboardMenu, fetchSalesMenu, fetchToolsMenu, fetchLojistasMenu])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    menuData,
    isFetching,
  }
}
